/* Shop Pay installments: paint the Shop logo black (theme ink) inside shopify-payment-terms shadow DOM, all product templates */
(function () {
  if (window.geShopInkBooted) return;
  window.geShopInkBooted = true;
  var SHOP_INK = 'shop-pay-logo,.shop-pay-logo,svg,img,[class*="logo" i]{filter:brightness(0)!important;color:#17160f!important}svg *{fill:#17160f!important}';

  function paintRoot(root, host) {
    if (!root || root.nodeType !== 11) return false;
    if (!root.querySelector('style[data-ge-shop-ink]')) {
      var style = document.createElement('style');
      style.setAttribute('data-ge-shop-ink', '');
      style.textContent = SHOP_INK;
      root.appendChild(style);
    }
    if (!root.__geShopWatch) {
      root.__geShopWatch = true;
      var obs = new MutationObserver(function () { paintShopLogo(host); });
      obs.observe(root, { childList: true, subtree: true });
    }
    var found = false;
    root.querySelectorAll('*').forEach(function (el) {
      if (el.shadowRoot && paintRoot(el.shadowRoot, host)) found = true;
      var tag = (el.tagName || '').toLowerCase();
      var cls = typeof el.className === 'string' ? el.className : '';
      if (tag === 'svg' || tag === 'img' || /logo/i.test(tag) || /logo/i.test(cls)) {
        el.style.setProperty('filter', 'brightness(0)', 'important');
        found = true;
      }
    });
    root.querySelectorAll('svg [fill]').forEach(function (shape) {
      var fill = (shape.getAttribute('fill') || '').toLowerCase();
      if (!fill || fill === 'none' || fill === 'transparent' || fill === 'currentcolor') return;
      if (fill === '#fff' || fill === '#ffffff' || fill === 'white') return;
      shape.setAttribute('fill', '#17160f');
      found = true;
    });
    return found;
  }

  function paintShopLogo(host) {
    var root = host.shadowRoot;
    if (!root) return false;
    var found = paintRoot(root, host);
    if (found) {
      host.dataset.geShopInk = 'on';
      host.classList.remove('ge-shop-ink');
    }
    return found;
  }

  function inkShopMarks() {
        var hosts = document.querySelectorAll('shopify-payment-terms');
    if (!hosts.length) return false;
    var done = true;
    hosts.forEach(function (host) {
      if (!paintShopLogo(host)) done = false;
    });
    return done;
  }

  function startShopInk() {
    if (startShopInk.timer) clearInterval(startShopInk.timer);
    var tries = 0;
    startShopInk.timer = setInterval(function () {
      tries += 1;
      if (inkShopMarks() || tries >= 60) {
        clearInterval(startShopInk.timer);
        startShopInk.timer = null;
        document.querySelectorAll('shopify-payment-terms').forEach(function (host) {
          if (host.dataset.geShopInk === 'on') return;
          host.classList.add('ge-shop-ink');
        });
      }
    }, 200);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', startShopInk);
  else startShopInk();
  document.addEventListener('shopify:section:load', startShopInk);
  document.addEventListener('variant:change', startShopInk);
  new MutationObserver(function (m) {
    if (m.some(function (r) { return [].some.call(r.addedNodes, function (n) { return n.nodeType === 1 && (n.matches('shopify-payment-terms') || n.querySelector && n.querySelector('shopify-payment-terms')); }); })) startShopInk();
  }).observe(document.body, { childList: true, subtree: true });
})();
